import { AccordionPlaceholder } from '../accordion-placeholder';
import { CollapsePanelTitle } from '../captions/collapse-panel-title';
import { HelpCenterContent } from '../help-center-content';

export const RoutingGuideHelpCenterContent = () => {
  return (
    <HelpCenterContent
      defaultActiveKey={[]}
      helpCaptionTitle="Help with Routing Guide"
      panelItems={[
        {
          children: <AccordionPlaceholder>Coming soon</AccordionPlaceholder>,
          key: '1',
          label: <CollapsePanelTitle>How to create Routing Guide</CollapsePanelTitle>,
        },
        {
          children: <AccordionPlaceholder>Coming soon</AccordionPlaceholder>,
          key: '2',
          label: <CollapsePanelTitle>How to Edit Routing Guide</CollapsePanelTitle>,
        },
      ]}
    />
  );
};
